// extracted by mini-css-extract-plugin
module.exports = {"option":"styles_option_2Ch32rzAFzQQiGmwtqmFJT","focused":"styles_focused_2nn9v_AkOsXvkQMC6Cdp9f","active":"styles_active_2x6y6VUHq4hvlaDuM4dpxa"};